import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Plus, Filter, Edit2, Trash2 } from 'lucide-react';
import { StatusBadge } from './components/StatusBadge';
import { SessionModal } from './components/SessionModal';
import { useAdminData } from '../contexts/AdminDataContext';
export function AdminSessions() {
  const {
    sessions,
    saveSession,
    deleteSession
  } = useAdminData();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedSession, setSelectedSession] = useState<any>(null);
  const handleEdit = (session: any) => {
    setSelectedSession(session);
    setIsModalOpen(true);
  };
  const handleNew = () => {
    setSelectedSession(null);
    setIsModalOpen(true);
  };
  const handleSave = (data: any) => {
    if (selectedSession) {
      saveSession({
        ...selectedSession,
        ...data
      });
    } else {
      saveSession(data);
    }
    setIsModalOpen(false);
  };
  return <div className="space-y-6" data-id="element-474">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4" data-id="element-475">
        <div data-id="element-476">
          <h1 className="font-display text-3xl font-bold text-earth mb-2" data-id="element-477">
            Calendario de Sesiones
          </h1>
          <p className="text-stone" data-id="element-478">
            Gestiona las clases programadas y sus horarios.
          </p>
        </div>
        <button onClick={handleNew} className="flex items-center gap-2 bg-sage text-white px-5 py-2.5 rounded-xl font-semibold hover:bg-sage/90 transition-colors shadow-sm" data-id="element-479">
          <Plus size={18} data-id="element-480" />
          Nueva Clase
        </button>
      </div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="bg-white rounded-2xl border border-mist shadow-sm overflow-hidden" data-id="element-481">
        <div className="p-4 border-b border-mist bg-sand/30 flex items-center gap-4" data-id="element-482">
          <button className="flex items-center gap-2 text-sm font-semibold text-stone bg-white border border-mist px-4 py-2 rounded-lg hover:bg-sand transition-colors" data-id="element-483">
            <Filter size={16} data-id="element-484" />
            Filtros
          </button>
          <div className="text-sm text-stone" data-id="element-485">
            Mostrando todas las sesiones futuras
          </div>
        </div>

        <div className="overflow-x-auto" data-id="element-486">
          <table className="w-full text-sm text-left" data-id="element-487">
            <thead className="text-xs text-stone uppercase bg-sand/10 border-b border-mist" data-id="element-488">
              <tr data-id="element-489">
                <th className="px-6 py-4 font-semibold" data-id="element-490">Fecha y Hora</th>
                <th className="px-6 py-4 font-semibold" data-id="element-491">Clase</th>
                <th className="px-6 py-4 font-semibold" data-id="element-492">Ubicación</th>
                <th className="px-6 py-4 font-semibold text-center" data-id="element-493">
                  Ocupación
                </th>
                <th className="px-6 py-4 font-semibold" data-id="element-494">Estado</th>
                <th className="px-6 py-4 font-semibold text-right" data-id="element-495">Acciones</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-mist" data-id="element-496">
              {sessions.map(session => <tr key={session.id} className="hover:bg-sand/10 transition-colors" data-id="element-497">
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-498">
                    <div className="font-bold text-earth" data-id="element-499">
                      {session.session_date}
                    </div>
                    <div className="text-stone" data-id="element-500">{session.start_time}</div>
                  </td>
                  <td className="px-6 py-4" data-id="element-501">
                    <div className="font-medium text-earth" data-id="element-502">
                      {session.class_name}
                    </div>
                  </td>
                  <td className="px-6 py-4" data-id="element-503">
                    <div className="text-stone" data-id="element-504">{session.location_name}</div>
                  </td>
                  <td className="px-6 py-4 text-center" data-id="element-505">
                    <span className="font-medium text-earth" data-id="element-506">
                      {session.capacity - session.spots_available} /{' '}
                      {session.capacity}
                    </span>
                  </td>
                  <td className="px-6 py-4" data-id="element-507">
                    <StatusBadge status={session.status} data-id="element-508" />
                  </td>
                  <td className="px-6 py-4 text-right" data-id="element-509">
                    <div className="flex items-center justify-end gap-2" data-id="element-510">
                      <button onClick={() => handleEdit(session)} className="p-2 text-stone hover:text-sage hover:bg-sage/10 rounded-lg transition-colors" title="Editar" data-id="element-511">
                        <Edit2 size={16} data-id="element-512" />
                      </button>
                      <button onClick={() => deleteSession(session.id)} className="p-2 text-stone hover:text-error hover:bg-error/10 rounded-lg transition-colors" title="Cancelar" data-id="element-513">
                        <Trash2 size={16} data-id="element-514" />
                      </button>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </motion.div>

      <SessionModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} onSave={handleSave} session={selectedSession} data-id="element-515" />
    </div>;
}